/**
 * Card Component
 * Flexible card container with optional header and footer
 */

import React from 'react';

const Card = ({
  children,
  title,
  header,
  footer,
  className = '',
  ...props
}) => {
  return (
    <div className={`rf-card ${className}`} {...props}>
      {header && <div className="rf-card-header">{header}</div>}
      {title && !header && (
        <div className="rf-card-header">
          <h2 className="rf-card-title">{title}</h2>
        </div>
      )}
      <div className="rf-card-body">{children}</div>
      {footer && <div className="rf-card-footer">{footer}</div>}
    </div>
  );
};

export default Card;
